import React from 'react';

const IconCheck = () => (
  <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="12" height="12">
    <polyline points="2,6 5,9 10,3"/>
  </svg>
);

export default function StepProgress({ steps, currentStep, current }) {
  const activeIndex = currentStep !== undefined ? currentStep : (current !== undefined ? current : 0);
  return (
    <div className="exam-steps">
      {steps.map((step, i) => {
        const label = typeof step === 'object' ? step.label : step;
        const isCompleted = i < activeIndex;
        const isCurrent = i === activeIndex;
        const cls = [
          'exam-step',
          isCompleted ? 'exam-step-completed' : '',
          isCurrent ? 'exam-step-active' : '',
        ].filter(Boolean).join(' ');
        return (
          <div key={i} className={cls}>
            <div className="exam-step-circle">
              {isCompleted ? <IconCheck /> : i + 1}
            </div>
            <div className="exam-step-label">{label}</div>
          </div>
        );
      })}
    </div>
  );
}
